import linkResolver from '~/utils/link-resolver'

const defaultLink = { href: '/' }

/**
 * Link serializer
 * @param link
 * @returns Serialized link
 */
export default function serializeLink(link) {
  if (!link?.link_type) return defaultLink

  switch (link?.link_type) {
    case 'Web':
      return {
        href: link?.url ?? null,
        target: link?.target ?? null,
        isExternal: true,
      }
    case 'Document':
      return link?.type ? { href: linkResolver(link) } : defaultLink
    default:
      return defaultLink
  }
}
